import { useRef, useState } from 'react';
import classNames from 'classnames';
import { IconVideoSquare } from '@/features/icons';
interface Props {
  url: string;
  thumbnail?: string;
  className?: string;
  showPlayIcon?: boolean;
}
export const VideoPlayer = ({
  url,
  thumbnail,
  showPlayIcon = false,
  className
}: Props) => {
  const [paused, setPaused] = useState(true);
  const videoElement = useRef<HTMLVideoElement | null>(null);
  const [playing, setPlaying] = useState(false);
  const updatePaused = (event: React.SyntheticEvent<HTMLVideoElement, Event>) => {
    setPaused(event.currentTarget.paused);
    setPlaying(event.type === 'playing');
  };
  const play = () => {
    if (videoElement.current) {
      videoElement.current.play();
    }
  };
  return <div className={classNames('relative h-full w-full', className)} data-sentry-component="VideoPlayer" data-sentry-source-file="video-player.tsx">
            <video ref={videoElement} className='h-full w-full' controls poster={thumbnail || ''} onCanPlay={updatePaused} onPlaying={updatePaused} onPause={updatePaused}>
                <source src={url} />
            </video>
            {!playing || paused ? <div className={classNames('absolute right-0 top-0 h-full w-full cursor-pointer items-center justify-center bg-surface-scrim-black lg:flex', showPlayIcon ? 'flex' : 'hidden')} onClick={play}>
                    {paused && <button aria-label='Play Video' className='flex h-6 w-6 items-center justify-center rounded-full md:h-14 md:w-14'>
                            <IconVideoSquare className='h-14 w-14 text-white' />
                        </button>}
                </div> : null}
        </div>;
};